
import "../style.css"
import React, { useState, useEffect } from "react";
import {useExtensionUrl} from "../hooks/useExtensionUrl";

interface HeaderProps {
    showInstallButton: boolean;
}

const Header: React.FC<{props: HeaderProps}> = ({props}) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const extensionUrl = useExtensionUrl();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Add scroll event listener to change header background
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Dynamic class based on scroll position
    const headerClass = `header top-0 left-0 z-40 flex w-full items-center fixed transition-all duration-200 ${
        isScrolled ? 'backdrop-blur-md shadow-sm' : 'bg-transparent'
    }`;



    return (

        <header className={headerClass}>
            <div className="container">
                <div className="relative -mx-4 flex items-center justify-between">
                    <div className="w-60 max-w-full px-4 xl:mr-12"><a className="header-logo block w-full py-8 "
                                                                      href="/">
                        <div
                            className="flex gap-3 items-center text-large text-blue-900 font-bold dark:text-white whitespace-nowrap">
                            <img alt="logo" loading="lazy" width="48" height="48" decoding="async" data-nimg="1" src="/pictures/icon48.png"/>PDF Merger
                        </div>
                    </a></div>
                    <div className="flex w-full items-center justify-between px-4">
                        <div>
                            <button id="navbarToggler" aria-label="Mobile Menu"
                                    onClick={toggleMenu}
                                    className="absolute right-4 top-1/2 block translate-y-[-50%] rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden">
                                    <span
                                        className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-white ${isMenuOpen ? 'top-[7px] rotate-45' : ''}`}></span>
                                <span
                                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-white ${isMenuOpen ? 'opacity-0' : ''}`}></span>
                                <span
                                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-white ${isMenuOpen ? 'top-[-8px] -rotate-45' : ''}`}></span>
                            </button>

                            <nav id="navbarCollapse" style={{marginTop: isMenuOpen ? '-20px' : '0px' }}
                                 className={`navbar absolute right-0 z-30 w-[250px] rounded border-[.5px] 
    border-body-color/50 bg-white py-4 px-6 duration-300 dark:border-body-color/20 
    dark:bg-dark lg:visible lg:static lg:w-auto lg:border-none lg:!bg-transparent 
    lg:p-0 lg:opacity-100 ${isMenuOpen ? 'visible opacity-100 top-[120%]' : 'invisible top-[120%] opacity-0'}`}
                            >
                                <ul className="block lg:flex lg:space-x-12">
                                    <li className="group relative"><a
                                        className="flex py-2 text-base text-dark group-hover:opacity-70 dark:text-white lg:mr-0 lg:inline-flex lg:py-6 lg:px-0"
                                        href="/">Home</a></li>
                                    <li className="group relative"><a
                                        className="flex py-2 text-base text-dark group-hover:opacity-70 dark:text-white lg:mr-0 lg:inline-flex lg:py-6 lg:px-0"
                                        href="/contact-us">Contact us</a></li>
                                    <a target="_blank"
                                       className="flex sm:hidden py-2 text-base text-dark group-hover:opacity-70 dark:text-white"
                                       href={extensionUrl}>Install
                                        the extension</a></ul>
                            </nav>
                        </div>

                        {props.showInstallButton && (
                            <div className="flex items-center justify-end pr-16 lg:pr-0"><a
                                className="z-0 group relative items-center justify-center box-border appearance-none select-none whitespace-nowrap font-normal subpixel-antialiased overflow-hidden tap-highlight-transparent outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 border-medium px-unit-6 min-w-unit-24 h-unit-12 text-medium gap-unit-3 rounded-large [&amp;>svg]:max-w-[theme(spacing.unit-8)] data-[pressed=true]:scale-[0.97] transition-transform-colors-opacity motion-reduce:transition-none bg-transparent border-primary text-primary data-[hover=true]:opacity-hover hidden sm:flex mr-6"
                                role="button" target="_blank"
                                href={extensionUrl}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                     aria-hidden="true" focusable="false" >
                                    <path fill="currentColor"
                                          d="M0 12c0-2.156.563-4.219 1.594-6l5.156 8.953C7.781 16.781 9.703 18 12 18c.656 0 1.266-.094 1.875-.281l-3.563 6.187C4.454 23.11 0 18.094 0 12Zm17.11 3.094A5.82 5.82 0 0 0 18 12c0-1.781-.797-3.375-2.063-4.5h7.172c.563 1.406.891 2.953.891 4.5 0 6.656-5.39 12-12 12l5.11-8.906ZM22.36 6H12c-2.953 0-5.344 2.11-5.906 4.828L2.53 4.641C4.734 1.828 8.156 0 12 0c4.406 0 8.297 2.438 10.36 6ZM7.874 12A4.131 4.131 0 0 1 12 7.875c2.25 0 4.125 1.875 4.125 4.125A4.131 4.131 0 0 1 12 16.125 4.101 4.101 0 0 1 7.875 12Z"></path>
                                </svg>
                                Install the extension</a></div>
                        )}

                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header